import { galleryImages } from '../../../mocks/gallery';

export function Gallery() {
  return (
    <section id="gallery" className="py-24 px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="text-xs uppercase tracking-[0.2em] text-gray-500 mb-4">PHOTO GALLERY</p>
          <h2 className="text-5xl font-bold text-gray-900" style={{ fontFamily: 'Playfair Display, serif' }}>
            Inside Our Shop
          </h2>
        </div>

        {/* Masonry Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {galleryImages.map((image, index) => (
            <div 
              key={index}
              className="group relative overflow-hidden rounded-2xl cursor-pointer"
              style={{ aspectRatio: image.aspectRatio }}
            >
              <img 
                src={image.url}
                alt={image.alt}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/15 transition-all duration-400"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}